module.exports = __webpack_public_path__ + "img/gift4-01-c07-k2.d77087f0.png";